import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import PhotoFilters from '../../components/PhotoFilters';

const PhotoFiltersPage: React.FC = () => (
  <ToolLayout
    title="Photo Filters Online - Brightness, Contrast, Saturation | AllTools"
    description="Apply photo filters online. Adjust brightness, contrast, saturation, and hue. Free image filter tool."
    canonicalPath="/photo-filters"
  >
    <PhotoFilters />
  </ToolLayout>
);

export default PhotoFiltersPage;
